import React, { createContext, useState, useContext } from 'react';
import { en } from '../locales/en';
import { vi } from '../locales/vi';

const LanguageContext = createContext();

export const useLanguage = () => useContext(LanguageContext);

// Translations dictionary
export const translations = {
    en,
    vi,
};

export const LanguageProvider = ({ children }) => {
    const [lang, setLang] = useState(
        () => localStorage.getItem('appLang') || 'vi'
    );

    const toggleLang = () => {
        const next = lang === 'vi' ? 'en' : 'vi';
        setLang(next);
        localStorage.setItem('appLang', next);
    };

    const t = (key) => translations[lang][key] ?? key;

    return (
        <LanguageContext.Provider value={{ lang, toggleLang, t }}>
            {children}
        </LanguageContext.Provider>
    );
};
